/**
 * Which auth adapter this build uses. Decided from build-time env only; kept
 * free of React so non-component modules (api/http.ts) can read it.
 *
 * - `mock`     — `VITE_MOCK_AUTH !== 'false'` (default for dev + autonomous build).
 * - `fleet`    — DEV ONLY. Requires BOTH `VITE_MOCK_AUTH === 'false'` AND
 *                `VITE_FLEET_AUTH === 'true'` (exactly). The site sits behind the
 *                fleet OAuth2 Proxy; see ./fleetAuth.ts.
 * - `firebase` — everything else with mock off: production.
 *
 * Any `VITE_FLEET_AUTH` value other than the exact string 'true' ('1', 'TRUE',
 * 'yes', unset) resolves to `firebase`, so a typo can never switch a
 * production build off Firebase.
 */
export type AuthMode = 'mock' | 'fleet' | 'firebase';

export function resolveAuthMode(): AuthMode {
  if (import.meta.env.VITE_MOCK_AUTH !== 'false') return 'mock';
  return import.meta.env.VITE_FLEET_AUTH === 'true' ? 'fleet' : 'firebase';
}
